import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase } from '@digibricks/core';
import { ImageSizeLimit } from '../../create/create-file-storage.usecase';
export var UPLOAD_CLASS_COVER_USE_CASE = 'UPLOAD_CLASS_COVER_USE_CASE';
export var CLASS_COVER_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export var CLASS_COVER_SIZE_LIMIT = ImageSizeLimit;
export var UploadClassCoverUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UploadClassCoverUseCase, _UseCase);

  var _super = _createSuper(UploadClassCoverUseCase);

  function UploadClassCoverUseCase(files, externalFiles) {
    var _this;

    _classCallCheck(this, UploadClassCoverUseCase);

    _this = _super.call(this);
    _this.files = files;
    _this.externalFiles = externalFiles;
    return _this;
  }

  _createClass(UploadClassCoverUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var file, classId, created, storage, uploaded;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = input.file, classId = input.classId;

                if (!(!CLASS_COVER_TYPES.includes(file.type) || file.size <= 0 || file.size > CLASS_COVER_SIZE_LIMIT)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.fail('Invalid class cover image.'));

              case 3:
                _context.next = 5;
                return this.files.create({
                  fileName: file.name,
                  mimeType: file.type,
                  size: file.size,
                  resourceType: 1,
                  usageType: 'class_cover',
                  linkedEntity: classId ? {
                    entityType: 'class',
                    entityId: classId
                  } : undefined,
                  metadata: {
                    sourceApp: 'test-maker'
                  }
                });

              case 5:
                created = _context.sent;

                if (!created.isFailure) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", Result.fail(created.error));

              case 8:
                storage = created.getValue();
                _context.next = 11;
                return this.externalFiles.create(file, storage.uploadUrl);

              case 11:
                uploaded = _context.sent;

                if (!uploaded.isFailure) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", Result.fail(uploaded.error));

              case 14:
                return _context.abrupt("return", Result.ok(storage.url));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UploadClassCoverUseCase;
}(UseCase);